interface ILPPAuthCommonLayoutProps {
  children: React.ReactNode;
}
export const LPPAuthCommonLayout = (props: ILPPAuthCommonLayoutProps) => {
  const { children } = props;
  return <div className="bg-gray-50">{children}</div>;
};
